import { CREATE_ORDER, RETRIEVE_ORDER, DELETE_ORDER } from "./types";

import OrderDataService from "../services/order.service";
import { parseNumber } from "../helpers/common";

export const createOrder =
	(
		id,
		id_company,
		tipe,
		id_card,
		code,
		code_po,
		date,
		due_date,
		note,
		ship_to,
		id_payment_method,
		tax_inclusive,
		detail,
		recurring,
		recurring_name
	) =>
	async (dispatch) => {
		try {
			if (tax_inclusive === "true") {
				tax_inclusive = true;
			}
			if (tax_inclusive === "false") {
				tax_inclusive = false;
			}

			code = code.toString();
			id_card = parseNumber(id_card);
			id_payment_method = parseNumber(id_payment_method);

			let formData = {
				id: id,
				id_company: id_company,
				tipe: tipe,
				id_card: id_card,
				code: code,
				code_po: code_po,
				date: date,
				due_date: due_date,
				note: note,
				ship_to: ship_to,
				id_payment_method: id_payment_method,
				tax_inclusive: tax_inclusive,
				detail: detail,
				recurring: recurring,
				recurring_name: recurring_name,
			};

			const res = await OrderDataService.create(formData);

			dispatch({
				type: CREATE_ORDER,
				payload: res.data,
			});

			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		}
	};

export const retrieveOrder = (params) => async (dispatch) => {
	try {
		const res = await OrderDataService.getAll(params);

		dispatch({
			type: RETRIEVE_ORDER,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};

export const deleteOrder = (id) => async (dispatch) => {
	try {
		const res = await OrderDataService.delete(id);

		dispatch({
			type: DELETE_ORDER,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};
